export default {
  getMedia: (object) => {
    return {
      src: object ? `${object.fields.file.url}` : '',
      width: object ? object.fields.file.details.image.width : 800,
      height: object ? object.fields.file.details.image.height : 600,
    }
  },
  scrollToY: (endY, duration) => {

    const from = window.pageYOffset || document.body.scrollTop
    const by = endY - from
    let currentIteration = 0
    const animIterations = Math.round(60 * duration)

    const easeOutCubic = (currentIteration, startValue, changeInValue, totalIterations) => {
      return changeInValue * (Math.pow(currentIteration / totalIterations - 1, 3) + 1) + startValue;
    }

    const scroll = () => {
      const value = easeOutCubic(currentIteration, from, by, animIterations);
      window.scrollTo(0, value)
      currentIteration++;
      if (currentIteration < animIterations) {
        requestAnimationFrame(scroll);
      }
    }

    scroll()
  },
  updateWindowTitle: (text) => {
    document.title = text
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/stores/Help.js